import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

import Featured from "~/Components/Featured";
import Message from "~/Components/Message";
import Notification from "~/Components/Notification";
import SubmitForm from "~/Components/Forms/Submit/SubmitForm";
import Tile from "~/Components/Tile";
import { Link } from "react-router-dom";

import axios from "@dreamchimney/react-axios";
import { postSubmit } from "~/api/postSubmit";

// import { library } from "@fortawesome/fontawesome-svg-core";
// import { fab } from "@fortawesome/free-brands-svg-icons";

import "./SubmitPage.less";

// library.add(fab);

const SubmitPage = () => {
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [failure, setFailure] = useState(false);
  const [preview, setPreview] = useState(false);
  const [previewOtd, setPreviewOtd] = useState({});
  const [payload, setPayload] = useState({});
  const previewRef = useRef();

  const onPreview = (previewPayload, finalPayload) => {
    console.log("previewPayload:", previewPayload);
    console.log("finalPayload:", finalPayload);
    setPreviewOtd(previewPayload);
    setPreview(true);
    setPayload(finalPayload);
    previewRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleSubmit = async (data) => {
    console.log("SUBMIT payload:", payload);
    setSaving(true);
    try {
      await postSubmit(axios, payload);
      setSaving(false);
      setPreview(false);
      setSaved(true);
      setFailure(false);
    } catch (err) {
      console.log("FAIL err:", err);
      setSaving(false);
      setFailure(true);
    }
  };

  if (saving) {
    return (
      <div className="submit-page-success" style={{ marginTop: "60px", marginBottom: "40px", color: "#fff" }}>
        <div style={{ textAlign: "center" }}>
          <Spinner animation="border" size="sm" /> Saving. Please hold...
        </div>
      </div>
    );
  }
  if (saved) {
    return (
      <div className="submit-page-success" style={{ marginBottom: "120px" }}>
        <div style={{ textAlign: "center" }}>
          <div className="pageTitle">
            <strong>Great Success!</strong>
          </div>
          <div className="pageTitle">
            <Link to="/">Now go check it out &raquo;</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="submit-page-component">
      <Helmet>
        <title>____ of the Day | Dream Chimney</title>
      </Helmet>
      <div ref={previewRef}>
        {!saved && preview && (
          <div className="submitPreview">
            <div className="previewHeader">
              <div className="pageTitle">★ PREVIEW ONLY ★</div>
              <div className="pageTitle">Review and click SUBMIT below to post your “____” of the Day</div>
            </div>
            <Tile archive={false} otd={previewOtd} preview />
            <div className="previewFooter">
              <Button variant="primary" onClick={() => handleSubmit()}>
                Submit Your "____" of the Day
              </Button>
            </div>
          </div>
        )}
      </div>
      <div>
        {failure && (
          <Notification>
            <p>
              <strong>There was a failure.</strong> Check to make sure you filled in all the correct items below and resubmit. Thanks.
            </p>
          </Notification>
        )}
      </div>
      <div className="pageTitle">Enter your “Of the Day” below...</div>
      <div className="SubmitFormWrapper">
        <Row className="with-col-list">
          <Col xs={12} md={8}>
            <Featured>
              <SubmitForm onPreview={onPreview} />
            </Featured>
          </Col>
          <Col xs={12} md={4}>
            <Message centered={false}>
              <div>
                <strong>Instructions</strong>
              </div>
              <div>1. Find the link or image you want to share</div>
              <div>2. Create a summary ___ of the Day title for it</div>
              <div>3. Add any text comment and tags to go with it</div>
              <div>
                4. Add File under tags, start typing in the "File Under" text field to find existing tags. Or create your own, just
                separated each with a comma. The linked tags below are there for easy access, just click to add the tag.
              </div>
              <div>
                5. Paste the image url or link and click preview to confirm. <br />
                <br />
                💡 TIP: Click <strong>"upload an image"</strong> to upload file from your desktop, screenshot etc. (Only a single image file
                is supported.)
              </div>
              <div>6. Click preview to see how it looks before you submit. If you make any changes you must preview it again.</div>
            </Message>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SubmitPage;
